import dynamic from "next/dynamic";

export const DynamicPlusDetailedListingPopup = dynamic(() =>
  import(".").then(module => module.PlusDetailedListingPopup),
);
